var _metadata, _sodipodinamedview, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _radialGradient, _linearGradient9, _linearGradient0, _radialGradient2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    sodipodiversion: 0.32,
    inkscapeversion: "1.2.1 (9c6d41e410, 2022-07-14)",
    sodipodidocname: "python-logo-only.svg",
    viewBox: "0 0 120 120",
    "inkscapeexport-filename": "python-logo-only.png",
    "inkscapeexport-xdpi": 232.44,
    "inkscapeexport-ydpi": 232.44,
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    xmlnsrdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnscc: "http://creativecommons.org/ns#",
    xmlnsdc: "http://purl.org/dc/elements/1.1/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata371"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfabout: ""
  }, /*#__PURE__*/React.createElement("dcformat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dctype", {
    rdfresource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _sodipodinamedview || (_sodipodinamedview = /*#__PURE__*/React.createElement("sodipodinamedview", {
    "inkscapewindow-height": 2080,
    "inkscapewindow-width": 1976,
    inkscapepageshadow: 2,
    inkscapepageopacity: 0,
    guidetolerance: 10,
    gridtolerance: 10,
    objecttolerance: 10,
    borderopacity: 1,
    bordercolor: "#666666",
    pagecolor: "#ffffff",
    id: "base",
    inkscapezoom: 2.1461642,
    inkscapecx: 91.558698,
    inkscapecy: 47.9926,
    "inkscapewindow-x": 1092,
    "inkscapewindow-y": 72,
    "inkscapecurrent-layer": "svg2",
    width: "210mm",
    height: "40mm",
    units: "mm",
    inkscapeshowpageshadow: 2,
    inkscapepagecheckerboard: 0,
    inkscapedeskcolor: "#d1d1d1",
    "inkscapedocument-units": "pt",
    showgrid: "false",
    "inkscapewindow-maximized": 0
  })), /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient2795"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b8b8b8",
      stopOpacity: 0.49803922
    },
    offset: 0,
    id: "stop2797"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#7f7f7f",
      stopOpacity: 0
    },
    offset: 1,
    id: "stop2799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient2787"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#7f7f7f",
      stopOpacity: 0.5
    },
    offset: 0,
    id: "stop2789"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#7f7f7f",
      stopOpacity: 0
    },
    offset: 1,
    id: "stop2791"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient3676"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b2b2b2",
      stopOpacity: 0.5
    },
    offset: 0,
    id: "stop3678"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b3b3b3",
      stopOpacity: 0
    },
    offset: 1,
    id: "stop3680"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient3236"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f4f4",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop3244"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "white",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop3240"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4671"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffd43b",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop4673"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffe873",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop4675"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4689"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#5a9fd4",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop4691"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#306998",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop4693"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 224.23996,
    y1: 144.75717,
    x2: -65.308502,
    y2: 144.75717,
    id: "linearGradient2987",
    xlinkHref: "#linearGradient4671",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.2702,99.61116)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 172.94208,
    y1: 77.475983,
    x2: 26.670298,
    y2: 76.313133,
    id: "linearGradient2990",
    xlinkHref: "#linearGradient4689",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.2702,99.61116)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    inkscapecollect: "always",
    xlinkHref: "#linearGradient4689",
    id: "linearGradient2587",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.2702,99.61116)",
    x1: 172.94208,
    y1: 77.475983,
    x2: 26.670298,
    y2: 76.313133
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    inkscapecollect: "always",
    xlinkHref: "#linearGradient4671",
    id: "linearGradient2589",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.2702,99.61116)",
    x1: 224.23996,
    y1: 144.75717,
    x2: -65.308502,
    y2: 144.75717
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    inkscapecollect: "always",
    xlinkHref: "#linearGradient4689",
    id: "linearGradient2248",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.2702,99.61116)",
    x1: 172.94208,
    y1: 77.475983,
    x2: 26.670298,
    y2: 76.313133
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    inkscapecollect: "always",
    xlinkHref: "#linearGradient4671",
    id: "linearGradient2250",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.2702,99.61116)",
    x1: 224.23996,
    y1: 144.75717,
    x2: -65.308502,
    y2: 144.75717
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    inkscapecollect: "always",
    xlinkHref: "#linearGradient4671",
    id: "linearGradient2255",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.562541,0,0,0.567972,-11.5974,-7.60954)",
    x1: 224.23996,
    y1: 144.75717,
    x2: -65.308502,
    y2: 144.75717
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    inkscapecollect: "always",
    xlinkHref: "#linearGradient4689",
    id: "linearGradient2258",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.562541,0,0,0.567972,-11.5974,-7.60954)",
    x1: 172.94208,
    y1: 76.176224,
    x2: 26.670298,
    y2: 76.313133
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    inkscapecollect: "always",
    xlinkHref: "#linearGradient2795",
    id: "radialGradient2801",
    cx: 61.518883,
    cy: 132.28575,
    fx: 61.518883,
    fy: 132.28575,
    r: 29.036913,
    gradientTransform: "matrix(1,0,0,0.177966,0,108.7434)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    inkscapecollect: "always",
    xlinkHref: "#linearGradient4671",
    id: "linearGradient1475",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.562541,0,0,0.567972,-14.99112,-11.702371)",
    x1: 150.96111,
    y1: 192.35176,
    x2: 112.03144,
    y2: 137.27299
  })), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
    inkscapecollect: "always",
    xlinkHref: "#linearGradient4689",
    id: "linearGradient1478",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.562541,0,0,0.567972,-14.99112,-11.702371)",
    x1: 26.648937,
    y1: 20.603781,
    x2: 135.66525,
    y2: 114.39767
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    inkscapecollect: "always",
    xlinkHref: "#linearGradient2795",
    id: "radialGradient1480",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.7490565e-8,-0.23994696,1.054668,3.7915457e-7,-83.7008,142.46201)",
    cx: 61.518883,
    cy: 132.28575,
    fx: 61.518883,
    fy: 132.28575,
    r: 29.036913
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linearGradient1478)",
      fillOpacity: 1
    },
    d: "M 54.918785,9.1927389e-4 C 50.335132,0.02221727 45.957846,0.41313697 42.106285,1.0946693 30.760069,3.0991731 28.700036,7.2947714 28.700035,15.032169 v 10.21875 h 26.8125 v 3.40625 h -26.8125 -10.0625 c -7.792459,0 -14.6157588,4.683717 -16.7499998,13.59375 -2.46181998,10.212966 -2.57101508,16.586023 0,27.25 1.9059283,7.937852 6.4575432,13.593748 14.2499998,13.59375 h 9.21875 v -12.25 c 0,-8.849902 7.657144,-16.656248 16.75,-16.65625 h 26.78125 c 7.454951,0 13.406253,-6.138164 13.40625,-13.625 v -25.53125 c 0,-7.2663386 -6.12998,-12.7247771 -13.40625,-13.9374997 C 64.281548,0.32794397 59.502438,-0.02037903 54.918785,9.1927389e-4 Z m -14.5,8.21875012611 c 2.769547,0 5.03125,2.2986456 5.03125,5.1249996 -2e-6,2.816336 -2.261703,5.09375 -5.03125,5.09375 -2.779476,-1e-6 -5.03125,-2.277415 -5.03125,-5.09375 -10e-7,-2.826353 2.251774,-5.1249996 5.03125,-5.1249996 z",
    id: "path1948"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linearGradient1475)",
      fillOpacity: 1
    },
    d: "m 85.637535,28.657169 v 11.90625 c 0,9.230755 -7.825895,16.999999 -16.75,17 h -26.78125 c -7.335833,0 -13.406249,6.278483 -13.40625,13.625 v 25.531247 c 0,7.266344 6.318588,11.540324 13.40625,13.625004 8.487331,2.49561 16.626237,2.94663 26.78125,0 6.750155,-1.95439 13.406253,-5.88761 13.40625,-13.625004 V 86.500919 h -26.78125 v -3.40625 h 26.78125 13.406254 c 7.792461,0 10.696251,-5.435408 13.406241,-13.59375 2.79933,-8.398886 2.68022,-16.475776 0,-27.25 -1.92578,-7.757441 -5.60387,-13.59375 -13.406241,-13.59375 z m -15.0625,64.65625 c 2.779478,3e-6 5.03125,2.277417 5.03125,5.093747 -2e-6,2.826354 -2.251775,5.125004 -5.03125,5.125004 -2.76955,0 -5.03125,-2.29865 -5.03125,-5.125004 2e-6,-2.81633 2.261697,-5.093747 5.03125,-5.093747 z",
    id: "path1950"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.44382,
      fill: "url(#radialGradient1480)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 15.4174,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1894",
    cx: 55.816761,
    cy: 127.70079,
    rx: 35.930977,
    ry: 6.9673119
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.46e4e98adf454119a970dfe0b79b21e2.svg";
export { ForwardRef as ReactComponent };